import { makeAutoObservable } from "mobx"
import { createStoreContext } from "reusable/mobx-store-utils/storeUtils"
import { GapDialogBigTabsProps } from "./GapDialogBigTabs"
import { notNull } from "@gap/utils/utils"
import { GapDialogStore } from "../GapDialogStore"

export default class GapDialogBigTabsStore {
   sp
   value = ''

   constructor(sp: GapDialogBigTabsProps & { gapDialogStore: GapDialogStore }) {
      makeAutoObservable(this)
      this.sp = sp
      // Set initial value without triggering button override during render
      const initialOption = sp.initialTab ? sp.options.find(option => option.label === sp.initialTab) : undefined
      this.value = notNull((initialOption ?? sp.options[0]).label)
   }

   get Component() {
      return notNull(this.sp.options.find(option => option.label === this.value)).component
   }

   initializeButtons = () => {
      const valueProps = notNull(this.sp.options.find(option => option.label === this.value))
      this.sp.gapDialogStore.overrideButtons = valueProps.buttons
   }
   
   isActive = (value: string) => {
      return value === this.value
   }

   clickHandler = (event: React.MouseEvent<HTMLElement>) => {
      const id = notNull(event.currentTarget.getAttribute("data-id"))
      this.setValue(id)
   }

   setValue = (value: string) => {
      this.value = value
      const valueProps = notNull(this.sp.options.find(option => option.label === value))

      this.sp.gapDialogStore.overrideButtons = valueProps.buttons
   }
}

export const { Provider: GapDialogBigTabsStoreProvider, useProvidedStore: useGapDialogBigTabsStore } = createStoreContext(GapDialogBigTabsStore)
